import React from 'react';
// logic

import styled from 'styled-components';
import { ModalBoldText } from '../modals/modalComponents';
// icons
import { ReactComponent as WhatsappIcon } from 'assets/icons/whatsapp.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/email.svg';

const t = {
  changes: 'Changes',
};

const ChangesIconContainer = styled.div`
  display: inline-flex;
  align-items: center;
  svg {
    width: 16px;
    height: 16px;
    path {
      fill: var(--grey-700, #54708c);
    }
  }
`;

const ChangesSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  width: 100%;
`;

const ChangesSummaryItemsContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  /* justify-content: center; */
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  background: var(--grey-200, #e2e8ee);
  flex-direction: column;
`;

const ChangesItemHeader = styled.div`
  color: var(--grey-700, #54708c);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`;

const ChangesItemBody = styled.div`
  color: var(--grey-700, #54708c);
  font-feature-settings: 'clig' off, 'liga' off;
  /* 16px/regular */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  display: flex;
  gap: 4px;
`;

const ChangeItemBodySubsection = styled.li`
  /* display: inline; */
`;

const ChangesSummary = ({ changes }) => {
  const hasShipperDataChanges = changes.shipper_data;
  const hasPickupChanges = changes.order_data?.pickup;
  const hasDropoffChanges = changes.order_data?.dropoff;
  const hasLoadChanges = changes.order_data?.loads_data || changes.loads_data;
  const hasServiceTypeChanges = changes.order_data?.service_type || changes.vehicle_details;
  const hasComplementaryInfoChanges = changes.order_data?.complementary_info;
  const hasPriceChanges = changes.price;
  const hasCostChanges = changes.cost;
  const hasDetectedChanges =
    hasShipperDataChanges ||
    hasPickupChanges ||
    hasDropoffChanges ||
    hasLoadChanges ||
    hasServiceTypeChanges ||
    hasComplementaryInfoChanges ||
    hasPriceChanges ||
    hasCostChanges;
  return (
    <ChangesSummaryContainer>
      <ModalBoldText>{t.cost_change_reasons}</ModalBoldText>
      <ChangesSummaryItemsContainer>
        {hasShipperDataChanges && (
          <div>
            <ChangesItemHeader>Shipper data:</ChangesItemHeader>
            {changes.shipper_data?.company_name && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Company:</ChangeItemBodySubsection>{' '}
                {changes.shipper_data.company_name.previous}
                {' >> '}
                {changes.shipper_data.company_name.current}
              </ChangesItemBody>
            )}
            {changes.shipper_data?.company_id && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Company ID:</ChangeItemBodySubsection>{' '}
                {changes.shipper_data.company_id.previous}
                {' >> '}
                {changes.shipper_data.company_id.current}
              </ChangesItemBody>
            )}
            {changes.shipper_data?.contact_name && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Contact name:</ChangeItemBodySubsection>{' '}
                {changes.shipper_data.contact_name.previous}
                {' >> '}
                {changes.shipper_data.contact_name.current}
              </ChangesItemBody>
            )}
            {changes.shipper_data?.phone && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Phone:</ChangeItemBodySubsection>{' '}
                {changes.shipper_data.phone.previous}
                {' >> '}
                {changes.shipper_data.phone.current}
              </ChangesItemBody>
            )}
            {changes.shipper_data?.notification_transports && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Notifications:</ChangeItemBodySubsection>{' '}
                <ChangesIconContainer>
                  {changes.shipper_data.notification_transports.previous[0].transport ===
                  'whatsapp' ? (
                    <WhatsappIcon />
                  ) : (
                    <EmailIcon />
                  )}
                </ChangesIconContainer>{' '}
                {changes.shipper_data.notification_transports.previous[0].transport === 'whatsapp'
                  ? changes.shipper_data.notification_transports.previous[0].phone_number
                  : changes.shipper_data.notification_transports.previous[0].email}
                {' >> '}
                <ChangesIconContainer>
                  {changes.shipper_data.notification_transports.current[0].transport ===
                  'whatsapp' ? (
                    <WhatsappIcon />
                  ) : (
                    <EmailIcon />
                  )}
                </ChangesIconContainer>{' '}
                {changes.shipper_data.notification_transports.current[0].transport === 'whatsapp'
                  ? changes.shipper_data.notification_transports.current[0].phone_number
                  : changes.shipper_data.notification_transports.current[0].email}
              </ChangesItemBody>
            )}
          </div>
        )}
        {hasPickupChanges && (
          <div>
            <ChangesItemHeader>Pickup:</ChangesItemHeader>
            {changes.order_data?.pickup.current.company_name && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Company:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.company_name}
                {' >> '}
                {changes.order_data?.pickup.current.company_name}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.address && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Address:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.address}
                {' >> '}
                {changes.order_data?.pickup.current.address}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.country && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Country:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.country}
                {' >> '}
                {changes.order_data?.pickup.current.country}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.zipcode && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Zipcode:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.zipcode}
                {' >> '}
                {changes.order_data?.pickup.current.zipcode}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.date && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Date:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.date}
                {' >> '}
                {changes.order_data?.pickup.current.date}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.time_from && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Time from:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.time_from}
                {' >> '}
                {changes.order_data?.pickup.current.time_from}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.time_to && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Time to:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.time_to}
                {' >> '}
                {changes.order_data?.pickup.current.time_to}
              </ChangesItemBody>
            )}
            {changes.order_data?.pickup.current.observations && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Observations:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.pickup.previous.observations}
                {' >> '}
                {changes.order_data?.pickup.current.observations}
              </ChangesItemBody>
            )}
          </div>
        )}
        {hasDropoffChanges && (
          <div>
            <ChangesItemHeader>Dropoff:</ChangesItemHeader>
            {changes.order_data?.dropoff.current.company_name && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Company:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.company_name}
                {' >> '}
                {changes.order_data?.dropoff.current.company_name}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.address && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Address:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.address}
                {' >> '}
                {changes.order_data?.dropoff.current.address}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.country && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Country:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.country}
                {' >> '}
                {changes.order_data?.dropoff.current.country}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.zipcode && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Zipcode:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.zipcode}
                {' >> '}
                {changes.order_data?.dropoff.current.zipcode}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.date && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Date:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.date}
                {' >> '}
                {changes.order_data?.dropoff.current.date}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.time_from && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Time from:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.time_from}
                {' >> '}
                {changes.order_data?.dropoff.current.time_from}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.time_to && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Time to:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.time_to}
                {' >> '}
                {changes.order_data?.dropoff.current.time_to}
              </ChangesItemBody>
            )}
            {changes.order_data?.dropoff.current.observations && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Observations:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.dropoff.previous.observations}
                {' >> '}
                {changes.order_data?.dropoff.current.observations}
              </ChangesItemBody>
            )}
          </div>
        )}
        {hasLoadChanges && (
          <div>
            <ChangesItemHeader>Load:</ChangesItemHeader>
            <ChangesItemBody>
              <ChangeItemBodySubsection>Load data changed</ChangeItemBodySubsection>
            </ChangesItemBody>
          </div>
        )}
        {hasServiceTypeChanges && (
          <div>
            <ChangesItemHeader>Service type:</ChangesItemHeader>
            {changes.order_data?.service_type?.current?.vehicle_type && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Vehicle:</ChangeItemBodySubsection>{' '}
                {changes.order_data?.service_type?.previous?.vehicle_type}
                {' >> '}
                {changes.order_data?.service_type?.current?.vehicle_type}
              </ChangesItemBody>
            )}
            {changes.vehicle_details && (
              <ChangesItemBody>
                <ChangeItemBodySubsection>Details:</ChangeItemBodySubsection>{' '}
                {changes.vehicle_details.previous.join(', ')}
                {' >> '}
                {changes.vehicle_details.current.join(', ')}
              </ChangesItemBody>
            )}
          </div>
        )}
        {hasComplementaryInfoChanges && (
          <div>
            <ChangesItemHeader>Complementary info:</ChangesItemHeader>
            <ChangesItemBody>
              <ChangeItemBodySubsection>Complementary info changed</ChangeItemBodySubsection>
            </ChangesItemBody>
          </div>
        )}
        {hasPriceChanges && (
          <div>
            <ChangesItemHeader>Quote:</ChangesItemHeader>
            <ChangesItemBody>
              <ChangeItemBodySubsection>Price:</ChangeItemBodySubsection>{' '}
              {changes.price.previous.amount} {changes.price.previous.currency} {'>'}
              {'>'} {changes.price.current.amount} {changes.price.current.currency}
            </ChangesItemBody>
          </div>
        )}
        {hasCostChanges && (
          <div>
            <ChangesItemHeader>Complementary info:</ChangesItemHeader>
            <ChangesItemBody>
              <ChangeItemBodySubsection>Cost:</ChangeItemBodySubsection>{' '}
              {changes.cost.previous.amount} {changes.cost.previous.currency} {'>'}
              {'>'} {changes.cost.current.amount} {changes.cost.current.currency}
            </ChangesItemBody>
          </div>
        )}
        {!hasDetectedChanges && (
          <div>
            <ChangesItemHeader>Ticket info:</ChangesItemHeader>
            <ChangesItemBody>
              <ChangeItemBodySubsection>Ticket info changed</ChangeItemBodySubsection>
            </ChangesItemBody>
          </div>
        )}
      </ChangesSummaryItemsContainer>
    </ChangesSummaryContainer>
  );
};

export default ChangesSummary;
